"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var Svg_1 = __importDefault(require("../Svg"));

var CreditCard = function CreditCard(_a) {
  var fill = _a.fill,
      props = __rest(_a, ["fill"]);

  return react_1.default.createElement(Svg_1.default, __assign({}, props, {
    viewBox: "0 0 30.571 19"
  }), react_1.default.createElement("g", {
    transform: "translate(-291.04 -47.34)"
  }, react_1.default.createElement("path", {
    fill: "#8c9196",
    d: "M318.54,47.34H294.109a3.086,3.086,0,0,0-3.069,3.071v12.86a3.087,3.087,0,0,0,3.071,3.069h24.431a3.087,3.087,0,0,0,3.069-3.069V50.409A3.087,3.087,0,0,0,318.54,47.34Zm-24.429,1h24.427a2.083,2.083,0,0,1,2.073,2.071v2.072H292.04v-2.07A2.083,2.083,0,0,1,294.111,48.34Zm24.429,17H294.113a2.083,2.083,0,0,1-2.073-2.071V53.483h28.571v9.784A2.084,2.084,0,0,1,318.54,65.34Z"
  }), react_1.default.createElement("path", {
    fill: "#8c9196",
    d: "M317.254,56.34H313.4a.5.5,0,0,0,0,1h3.857a.5.5,0,0,0,0-1Z"
  }), react_1.default.createElement("path", {
    fill: "#8c9196",
    d: "M305.683,56.34H295.4a.5.5,0,0,0,0,1h10.286a.5.5,0,0,0,0-1Z"
  }), react_1.default.createElement("path", {
    fill: "#8c9196",
    d: "M299.254,58.911H295.4a.5.5,0,0,0,0,1h3.857a.5.5,0,0,0,0-1Z"
  })));
};

CreditCard.displayName = 'CreditCard';
exports.default = CreditCard;